import { Component, Input} from '@angular/core';
import { AbstractControl, AbstractControlDirective } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'extended-input',
  templateUrl: './extended-input.component.html',
  styleUrls: ['./extended-input.component.scss']
})
export class ExtendedInputComponent {

  private readonly errorMessages = {
    required: () => `${this.translate.instant('VALIDATION.REQUIRED')}`,
    maxlength: params => `${this.translate.instant('VALIDATION.MAX_LENGTH')} ${params.requiredLength}`,
    minlength: params => `${this.translate.instant('VALIDATION.MIN_LENGTH')} ${params.requiredLength}`,
    email: () => this.translate.instant('VALIDATION.EMAIL'),
    pattern: () => this.translate.instant('VALIDATION.CHAR_NOT_ALLOWED'),
    ngbDate: () => this.translate.instant('VALIDATION.DATE_NOT_IN_RANGE')
  };

  // get input form control for validation error messages display
  @Input() inputControl: AbstractControlDirective | AbstractControl;

  // get input note to display under it
  @Input() inputUnderNote: string;

  additionalValidationParam: string;

  constructor(public translate: TranslateService) { }

  isShowErrors(): boolean{
      return this.inputControl && this.inputControl.errors && (this.inputControl.dirty || this.inputControl.touched);
  }

  getRelevantErrorMessage(): string {
    const errorsArray = Object.keys(this.inputControl.errors);
    const field = errorsArray[0];
    return this.getMessage(field, this.inputControl.errors[field]);
  }

  private getMessage(type: string, params: any): string {
    return this.errorMessages[type](params);
  }

}
